import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { useTheme } from '@mui/material';
import { TextField, Button, Snackbar, Alert } from '@mui/material'
import axios from 'axios'
import { useSelector } from 'react-redux';
import DaumPostcode from 'react-daum-postcode';
import { useLocation, useNavigate } from 'react-router-dom';
import { TbLoader } from 'react-icons/tb';
import mainPath from '../../../utils/path';

const useStyles = makeStyles((theme)=>({
  main: {
    
  },
  box:{
    maxWidth:'1800px',
    margin:'0 auto',
    padding:'0 20px',

    fontFamily:[
      'Noto Sans KR'
    ],
  },
  orderEditBlockH1:{
    padding:'40px 0 20px 10px',
    fontWeight:'700',
    fontSize:'22px',
  },
  datagridBox: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  datagridTop: {
    display: 'flex',
    borderTop: '1px solid #D3D3D3',
    borderBottom: '1px solid #D3D3D3',
  },
  datagridTopItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid #D3D3D3',
    borderTop: 'none',
    borderBottom: 'none',
  },
  contBox: {
    display: 'flex',
    borderBottom: '1px solid #D3D3D3',
  },
  contBoxItem: {
    // display: 'flex',
    // alignItems: 'center',
    // justifyContent: 'center',
    border: '1px solid #D3D3D3',
    borderTop: 'none',
    borderBottom: 'none',
    wordBreak:'break-all',

    [theme.breakpoints.down(1025)]: {
      fontSize:'11px'          
    }

  },
  checkBoxMain: {
    width: '5%',
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center'
  },
  checkBoxItm: {
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center'
  },
  textLeft: {
    display: 'flex', 
    flexDirection: 'row', 
    justifyContent: 'start', 
    alignItems: 'center'
  },
  textRight: {
    display: 'flex', 
    flexDirection: 'row', 
    justifyContent: 'center', 
    alignItems: 'center'
  },
  textMiddle: {
    display: 'flex', 
    height: '100%',
    flexDirection: 'row', 
    justifyContent: 'center', 
    alignItems: 'center'
  },
  imageText: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'start'
  },
  btnDiv:{
    display:'flex',
    justifyContent:'center',
    marginTop:'30px'
  },
  changeBtnDiv:{
    display:'flex',
    margin:'50px 0',
    flexDirection:'column',
    paddingBottom:'30px',
  },
  changeBtnBox:{
    display:'flex',
    justifyContent:'start',
    marginTop:'10px',
  },
  btnButton:{
    margin:'0 20px'
  },
  spanSpan:{
    fontSize:'18px',
    fontWeight:'500',
    width:'250px',
    marginRight:'10px',

    [theme.breakpoints.down(1025)]: {
      marginBottom:'10px',
      textAlign:'center'
    }
  },
  dataDiv:{
    borderBottom:'1px solid #e2e2e2',
    padding:'10px 0',
  },
  dataDivSpan:{
    fontSize:'18px',
    fontWeight:'500',
    display:'block',
    padding:'0 0 10px 0',
  },
  dataDivspanSpan:{
  },
  fourthDiv:{
    padding:'50px 0',
  },
  innerDiv:{
    padding:'20px 10px',
    display:'flex',
    alignItems:'center',
    borderBottom:'1px solid #e2e2e2',

    [theme.breakpoints.down(1025)]: {
      flexDirection:'column',
    }
  },
  orderEditTextarea:{
    width:'800px',
    height:'300px',
    border:'1px solid #ccc',

    [theme.breakpoints.down(1025)]: {
      width:'100%'
    },
  },
  fifthDiv:{
    margin:'50px 0',
  },
  sixthDiv:{
    margin:'50px 0',
    paddingBottom:'50px'
  },
  addressBtn:{
    width:'100px',
    height:'59px',
    marginRight:'10px',

    [theme.breakpoints.down(1025)]: {
      marginRight:'0',
      margin:'0px 0 20px 0'
    },
  },
  openPostcodeTextFieldDiv:{
    padding:'10px 0'
  },
  orderH1:{
    fontSize:'23px',
    
  },
  load:{
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
  },
  loadingIcon:{
    color:'#007235',
    fontSize:'50px',
    animation:'$loadSpin 5s infinite'
  },
  "@keyframes loadSpin":{
    from: { transform:'rotate(0deg)' },
    to: { transform:'rotate(1turn)' }
  },

}));


const OrderEdit = () => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const location = useLocation();
  let navigate = useNavigate();
  const sendCost = parseInt(useSelector(state => state.config.shopDefaultConfig.de_send_cost_list));
  const row = [
    {name: '상품명', width: '40%'},
    {name: '상태', width: '20%'},
    {name: '수량', width: '20%'},
    {name: '가격', width: '20%'},
  ];
  const [picList, setPicList] = useState([])

  const [data, setData] = useState([])

  const [orderDetail1, setOrderDetail1] = useState({})
  const [orderDetail2, setOrderDetail2] = useState({})
  const [orderDetail3, setOrderDetail3] = useState({})

  const [openPostcode1, setOpenPostcode1] = useState(false);
  const [openPostcode2, setOpenPostcode2] = useState(false);

  const [errSnack, setErrSnack] = useState(false);
  const [succSnack, setSuccSnack] = useState(false);

  const [loading, setLoading] = useState(false)

  useEffect(() => {
    window.scrollTo(0, 0);

    return () => {
      setPicList([])
      setData([])
      setOrderDetail1({})
      setOrderDetail2({})
      setOrderDetail3({})
      setOpenPostcode1(false)
      setOpenPostcode2(false)
    }
  }, [])

  const getItem = async() => {
    try {
      setLoading(true)
      const res = await axios.post('/api/adm/getOrderView/', {od_id: location.state.od_id} )

      if(res.data.success === false) {
        setErrSnack(true)
        setLoading(false)
      }else{
        let details = res.data.result[0]

        setOrderDetail1({
          odId: details['od_id'], 
          mbId: details['mb_id'],
          odShopMemo: details['od_shop_memo'], 
          odNum: details['od_num'], 
          picId: details['pic_id']
        })

        setOrderDetail2({
          odId: details['od_id'], 
          odCartPrice: details['od_cart_price'], 
          odSendCost: details['od_send_cost'], 
          odReceiptPoint: details['od_receipt_point'],
          odCancelPrice: details['od_cancel_price'],
          odBankAccount: details['od_bank_account'],
          odReceiptPrice: details['od_receipt_price'],
          odDepositName: details['od_deposit_name'],
          odMisu: details['od_misu'],
        })
        setOrderDetail3({
          odId: details['od_id'], 
          odName: details['od_name'], 
          odTel: details['od_tel'], 
          odHp: details['od_hp'],
          odZip1: details['od_zip1'],
          odZip2: details['od_zip2'],
          odAddr1: details['od_addr1'],
          odAddr2: details['od_addr2'],
          odAddr3: details['od_addr3'], 
          odEmail: details['od_email'], 
          odIp: details['od_ip'],
          odBname: details['od_b_name'],
          odBtel: details['od_b_tel'],
          odBhp: details['od_b_hp'],
          odBzip1: details['od_b_zip1'],
          odBzip2: details['od_b_zip2'], 
          odBaddr1: details['od_b_addr1'], 
          odBaddr2: details['od_b_addr2'],
          odBaddr3: details['od_b_addr3'],
          odHopeDate: details['od_hope_date'],
          odMemo: details['od_memo'],
        })

        setData(res.data.result.reduce((result, item) => ([
          ...result, 
          [
          {id: item['od_id'], ctId: item['ct_id'], mbId: item['mb_id'], itId: item['it_id'], data: item['it_name'], type: 'imageText', img: item['it_img1']},
          {id: item['od_id'], ctId: item['ct_id'], mbId: item['mb_id'], itId: item['it_id'], data: item['ct_status'], type: 'textMiddle'},
          {id: item['od_id'], ctId: item['ct_id'], mbId: item['mb_id'], itId: item['it_id'], data: item['ct_qty'], type: 'textMiddle'},
          {id: item['od_id'], ctId: item['ct_id'], mbId: item['mb_id'], itId: item['it_id'], data: item['ct_price'], type: 'textMiddlePrice'},
          ]
        ]), []))
        setPicList(res.data.picList)
        setLoading(false)
      }
      
        
  
    } catch (e) {
      setErrSnack(true)
      setLoading(false)
      console.log(e)
    }
  }


  useEffect(() => {
    if(location.state.od_id){
      getItem()
    }
  } , [location.state.od_id])


  const editStatus = async(status) => {
    try {
      const res = await axios.post('/api/adm/orderChangeStatus/', 
      {
        od_id: data[0][0].id, 
        mb_id: data[0][0].mbId, 
        od_status: status, 
        od_send_cost: sendCost
      } )

      if(res.data.success === false){
        setErrSnack(true)
        console.log('실패')
        return ;
      }
      setSuccSnack(true)
      getItem()

  
    } catch (e) {
      setErrSnack(true)
      console.log(e)
    }
  } 
  

  const editDetail1 = async() => {
    try {
      const res = await axios.post('/api/adm/orderEditMemo/', 
        {
          od_id: orderDetail1.odId, 
          od_shop_memo: orderDetail1.odShopMemo, 
          od_num: orderDetail1.odNum,
          pic_id: orderDetail1.picId
        })

      if(res.data.success === false){
        setErrSnack(true)
        console.log('실패')
        return ;
      }
      setSuccSnack(true)
      getItem()

  
    } catch (e) {
      setErrSnack(true)
      console.log(e)
    }
  }

  const editDetail2 = async() => {
    try {
      const res = await axios.post('/api/adm/orderEditDeliveryInfo/', 
        {
          od_id: orderDetail3.odId, 
          od_name: orderDetail3.odName, 
          od_tel: orderDetail3.odTel,
          od_hp: orderDetail3.odHp,
          od_zip1: orderDetail3.odZip1,
          od_zip2: orderDetail3.odZip2,
          od_addr1: orderDetail3.odAddr1,
          od_addr2: orderDetail3.odAddr2,
          od_addr3: orderDetail3.odAddr3,
          od_email: orderDetail3.odEmail,
          od_b_name: orderDetail3.odBname,
          od_b_tel: orderDetail3.odBtel,
          od_b_hp: orderDetail3.odBhp,
          od_b_zip1: orderDetail3.odBzip1,
          od_b_zip2: orderDetail3.odBzip2,
          od_b_addr1: orderDetail3.odBaddr1,
          od_b_addr2: orderDetail3.odBaddr2,
          od_b_addr3: orderDetail3.odBaddr3,
          od_hope_date: orderDetail3.odHopeDate,
        })

      if(res.data.success === false){
        setErrSnack(true)
        console.log('실패')
        return ;
      }
      setSuccSnack(true)
      getItem()

  
    } catch (e) {
      setErrSnack(true)
      console.log(e)
    }
  }

  const snackClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setErrSnack(false);
    setSuccSnack(false)
  };



  return (
    <div className={classes.orderEditBlock}>
      {loading ? (
        <div className={classes.load}>
          <TbLoader className={classes.loadingIcon}/>
        </div>
      ) : (
      <>
      <div className={classes.box}>
        <h1 className={classes.orderEditBlockH1}>주문내역 상세</h1>
        <div className={classes.datagridBox}>
          <div className={classes.datagridTop}>

            {row.map((item, index) => (
                      <div key={index} className={classes.datagridTopItem} style={{width: item.width}}>
                        {item.name}
                      </div>
            ))}
          </div>

          {data.map((dataItem, dataIndex) => {
            return(
                    <div key={dataIndex} className={classes.contBox}>

                        {dataItem.map((item, index) => {
                          return(
                                <div key={index} className={classes.contBoxItem} style={{width: row[index].width}}>
                                  {item.type === 'textLeft' && (
                                    <h3 className={classes.textLeft}>{item.data}</h3>
                                  )}
                                  {item.type === 'textRight' && (
                                    <h3 className={classes.textRight}>{item.data}</h3>
                                  )}
                                  {item.type === 'textMiddle' && (
                                    <h3 className={classes.textMiddle}>{item.data}</h3>
                                  )}
                                  {item.type === 'textMiddlePrice' && (
                                    <h3 className={classes.textMiddle}>{item.data && item.data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</h3>
                                  )}
                                  {item.type === 'imageText' && ( // 이미지 어디감?
                                    <div className={classes.imageText}>
                                      <img
                                        style={{width: 50, height: 50, marginRight: 5, marginLeft: 5}}
                                        src={`${mainPath}/media/data/item/${item.img}`} 
                                      />
                                      <h3>{item.data}</h3>
                                    </div>
                                  )}
                                  {item.type === 'numberfield' && (
                                    <TextField
                                      hiddenLabel
                                      id="filled-hidden-label-small"
                                      value={item.data}
                                      variant="filled"
                                      size="small"
                                      fullWidth
                                      type='number'
                                      onChange={(e) => {
                                          let dataList = [...data]
                                          let arrayItm = {...dataList[dataIndex][index], data: parseInt(e.target.value)}
                                          dataList[dataIndex][index] = arrayItm
                                          setData(dataList)}
                                        }
                                    />
                                  )}                    

                                </div>
                        )})}
                    </div>
          )})}

        </div>
      </div>

      <div className={classes.box}>
        <div className={classes.changeBtnDiv}>
          <h1 className={classes.orderH1}>주문 및 장바구니 상태 변경</h1>
          <div className={classes.changeBtnBox}>
            <div>
              <Button variant="outlined" onClick={() => editStatus('주문')}>
                주문
              </Button>
            </div>
            <div className={classes.btnButton}>
              <Button variant="outlined" onClick={() => editStatus('완료')}>
                완료
              </Button>
            </div>
            <div>
              <Button variant="outlined" onClick={() => editStatus('취소')}>
                취소
              </Button>
            </div>
          </div>
        </div>
      </div>

      <div className={classes.box}>
        <h1 className={classes.orderH1}>주문결제 내역</h1>
        <div className={classes.dataDiv}>
          <span className={classes.dataDivspanSpan}>주문번호 : </span>
          {orderDetail2.odId}
        </div>
        <div className={classes.dataDiv}>
          <span className={classes.dataDivspanSpan}>주문총액 : </span>
          {orderDetail2.odCartPrice &&  orderDetail2.odCartPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
        </div>
        <div className={classes.dataDiv}>
          <span className={classes.dataDivspanSpan}>배송비 : </span>
          {orderDetail2.odSendCost && orderDetail2.odSendCost.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
        </div>
        <div className={classes.dataDiv}>
          <span className={classes.dataDivspanSpan}>포인트 : </span>
          {orderDetail2.odReceiptPoint && orderDetail2.odReceiptPoint.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
        </div>
        <div className={classes.dataDiv}>
          <span className={classes.dataDivspanSpan}>총결제액 : </span>
          {orderDetail2.odReceiptPrice && orderDetail2.odReceiptPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
        </div>
        <div className={classes.dataDiv}>
          <span className={classes.dataDivspanSpan}>주문취소 : </span>
          {orderDetail2.odCancelPrice && orderDetail2.odCancelPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
        </div>
        <div className={classes.dataDiv}>
          <span className={classes.dataDivspanSpan}>미수금 : </span>
          {orderDetail2.odMisu && orderDetail2.odMisu.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
        </div>
      </div>

      

      <div className={classes.fourthDiv}>
        <div className={classes.box}>
          <div className={classes.innerDiv}>
            <span className={classes.spanSpan}>순서번호</span>
            <TextField
              hiddenLabel
              id="filled-hidden-label-small"
              value={orderDetail1.odNum}
              variant="filled"
              style={{ width:'250px' }}
              type='number'
              onChange={(e) => {
                  let val = parseInt(e.target.value)
                  let dataList = {...orderDetail1, odNum: val}
                  setOrderDetail1(dataList)
                }}
            />
          </div>
          <div className={classes.innerDiv}>
            <span className={classes.spanSpan}>담당자</span>
            {picList.length > 0 && (
              <h3 
                className={classes.textRight}
              >
                {picList.find(itm => itm['pic_id'] === orderDetail1.picId)['pic_name']}
              </h3>
            )}
          </div>
          <div className={classes.innerDiv}>
            <span className={classes.spanSpan}>상점메모</span>
            <textarea 
              style={{ width:'250px' }}
              className={classes.orderEditTextarea}
              value={orderDetail1.odShopMemo} 
              onChange={(e) => {
                let val = e.target.value
                let dataList = {...orderDetail1, odShopMemo: val}
                setOrderDetail1(dataList)
              }} 
            />
          </div>
  
          <div className={classes.btnDiv}>
            <Button 
              variant="outlined" 
              onClick={() => editDetail1()}
              style={{ margin:'0 20px'}}
            >
              변경1
            </Button>
            <Button 
              variant="outlined" 
              onClick={() => {
                navigate("/DashboardMain/orderListConfig");
              }}
            >
              목록
            </Button>
          </div>
        </div>
      </div>








      <div className={classes.fifthDiv}>
        <div className={classes.box}>
          <h1 className={classes.orderH1}>주문하신분</h1>
          <div className={classes.innerDiv}>
            <span className={classes.spanSpan}>이름</span>
            <TextField 
              style={{ width:'250px' }}
              value={orderDetail3.odName} 
              hiddenlabel="true" 
              variant="outlined"
              onChange={(e) => {
                let val = e.target.value
                let dataList = {...orderDetail3, odName: val}
                setOrderDetail3(dataList)
              }} 
            />
          </div>
          <div className={classes.innerDiv}>
            <span className={classes.spanSpan}>전화번호</span>
            <TextField 
              style={{ width:'250px' }}
              value={orderDetail3.odTel} 
              hiddenlabel="true" 
              variant="outlined" 
              onChange={(e) => {
                let val = e.target.value
                let dataList = {...orderDetail3, odTel: val}
                setOrderDetail3(dataList)
              }} 
            />
          </div>
          <div className={classes.innerDiv}>
            <span className={classes.spanSpan}>핸드폰</span>
            <TextField 
              style={{ width:'250px' }}
              value={orderDetail3.odHp}  
              hiddenlabel="true" 
              variant="outlined" 
              onChange={(e) => {
                let val = e.target.value
                let dataList = {...orderDetail3, odHp: val}
                setOrderDetail3(dataList)
              }} 
            />
          </div>
          <div className={classes.innerDiv}>
            <span className={classes.spanSpan}>주소</span>
            <button 
              onClick={() => setOpenPostcode1(!openPostcode1)}
              className={classes.addressBtn}
            >
              주소검색
            </button>
            {openPostcode1 && 
              <DaumPostcode 
                  onComplete={(data) => {
                    let zip1 = data.zonecode.substr(0, 3);
                    let zip2 = data.zonecode.substr(3, 3);
                    let addr1 = data.address
                    let dataList = {...orderDetail3, odZip1: zip1, odZip2: zip2, odAddr1: addr1}
                    setOrderDetail3(dataList)
                    setOpenPostcode1(false);
                  }}
                  autoClose={false} 
            />}
            <div className={classes.openPostcodeTextFieldDiv}>
              <TextField 
                style={{ width:'250px'}}
                value={orderDetail3.odZip1 + orderDetail3.odZip2}
                InputProps={{
                  readOnly: true,
                }}   
                hiddenlabel="true" 
                variant="outlined" 
              />
            </div>
            <div className={classes.openPostcodeTextFieldDiv}>
              <TextField 
                style={{ width:'250px'}}
                value={orderDetail3.odAddr1}
                InputProps={{
                  readOnly: true,
                }}  
                hiddenlabel="true" 
                variant="outlined" 
              />
            </div>
            <div className={classes.openPostcodeTextFieldDiv}>
              <TextField 
                style={{ width:'250px'}}
                value={orderDetail3.odAddr2}  
                hiddenlabel="true" 
                variant="outlined" 
                onChange={(e) => {
                  let val = e.target.value
                  let dataList = {...orderDetail3, odAddr2: val}
                  setOrderDetail3(dataList)
                }} 
              />
            </div>
            <div className={classes.openPostcodeTextFieldDiv}>
              <TextField 
                style={{ width:'250px'}}
                value={orderDetail3.odAddr3}  
                hiddenlabel="true" 
                variant="outlined" 
                onChange={(e) => {
                  let val = e.target.value
                  let dataList = {...orderDetail3, odAddr3: val}
                  setOrderDetail3(dataList)
                }} 
              />
            </div>
          </div>
          <div className={classes.innerDiv}>
            <span className={classes.spanSpan}>E-mail</span>
            <TextField 
              style={{ width:'250px' }}
              value={orderDetail3.odEmail}  
              hiddenlabel="true" 
              variant="outlined" 
              onChange={(e) => {
                let val = e.target.value
                let dataList = {...orderDetail3, odEmail: val}
                setOrderDetail3(dataList)
              }} 
            />
          </div>
          <div className={classes.innerDiv}>
            <span className={classes.spanSpan}>IP Address</span>
            {orderDetail3.odIp}
          </div>
        </div>
      </div>

      <div className={classes.sixthDiv}>
        <div className={classes.box}>
          <h1 className={classes.orderH1}>받으시는분</h1>
          <div className={classes.innerDiv}>
            <span className={classes.spanSpan}>이름</span>
            <TextField 
              style={{ width:'250px' }}
              value={orderDetail3.odBname}  
              hiddenlabel="true" 
              variant="outlined" 
              onChange={(e) => {
                let val = e.target.value
                let dataList = {...orderDetail3, odBname: val}
                setOrderDetail3(dataList)
              }} 
            />
          </div>
          <div className={classes.innerDiv}>
            <span className={classes.spanSpan}>전화번호</span>
            <TextField 
              style={{ width:'250px' }}
              value={orderDetail3.odBtel}  
              hiddenlabel="true" 
              variant="outlined" 
              onChange={(e) => {
                let val = e.target.value
                let dataList = {...orderDetail3, odBtel: val}
                setOrderDetail3(dataList)
              }} 
            />
          </div>
          <div className={classes.innerDiv}>
            <spanv className={classes.spanSpan}>핸드폰</spanv>
            <TextField 
              style={{ width:'250px' }}
              value={orderDetail3.odBhp}  
              hiddenlabel="true" 
              variant="outlined"
              onChange={(e) => {
                let val = e.target.value
                let dataList = {...orderDetail3, odBhp: val}
                setOrderDetail3(dataList)
              }}  
            />
          </div>
          <div className={classes.innerDiv}>
            <span className={classes.spanSpan}>주소</span>
            <button 
              onClick={() => setOpenPostcode2(!openPostcode2)}
              className={classes.addressBtn}
            >
              주소검색            
            </button>
            {openPostcode2 && 
              <DaumPostcode 
                  onComplete={(data) => {
                    let zip1 = data.zonecode.substr(0, 3);
                    let zip2 = data.zonecode.substr(3, 3);
                    let addr1 = data.address
                    let dataList = {...orderDetail3, odBzip1: zip1, odBzip2: zip2, odBaddr1: addr1}
                    setOrderDetail3(dataList)
                    setOpenPostcode2(false);
                  }}
                  autoClose={false} 
            />}
            <div className={classes.openPostcodeTextFieldDiv}>
              <TextField 
                style={{ width:'250px'}}
                value={orderDetail3.odBzip1 + orderDetail3.odBzip2}
                InputProps={{
                  readOnly: true,
                }}   
                hiddenlabel="true" 
                variant="outlined" 
              />
            </div>
            <div className={classes.openPostcodeTextFieldDiv}>
              <TextField 
                style={{ width:'250px'}}
                value={orderDetail3.odBaddr1}
                InputProps={{
                  readOnly: true,
                }}  
                hiddenlabel="true" 
                variant="outlined" 
              />
            </div>
            <div className={classes.openPostcodeTextFieldDiv}>
              <TextField 
                style={{ width:'250px'}}
                value={orderDetail3.odBaddr2}  
                hiddenlabel="true" 
                variant="outlined" 
                onChange={(e) => {
                  let val = e.target.value
                  let dataList = {...orderDetail3, odBaddr2: val}
                  setOrderDetail3(dataList)
                }} 
              />
            </div>
            <div className={classes.openPostcodeTextFieldDiv}>
              <TextField 
                style={{ width:'250px'}}
                value={orderDetail3.odBaddr3}  
                hiddenlabel="true" 
                variant="outlined" 
                onChange={(e) => {
                  let val = e.target.value
                  let dataList = {...orderDetail3, odBaddr3: val}
                  setOrderDetail3(dataList)
                }} 
              />
            </div>
          </div>
          <div className={classes.innerDiv}>
            <span className={classes.spanSpan}>희망배송일</span>
            <TextField 
              style={{ width:'250px'}}
              value={orderDetail3.odHopeDate}  
              hiddenlabel="true" 
              variant="outlined" 
              onChange={(e) => {
                let val = e.target.value
                let dataList = {...orderDetail3, odHopeDate: val}
                setOrderDetail3(dataList)
              }} 
            />
          </div>
          <div className={classes.innerDiv}>
            <span className={classes.spanSpan}>전달 메세지</span>
            {orderDetail3.odMemo}
          </div>
          <div className={classes.btnDiv}>
            <Button 
              variant="outlined" 
              onClick={() => editDetail2()}
              style={{ margin:'0 20px'}}
            >
              변경2
            </Button>
            <Button 
              variant="outlined" 
              onClick={() => {
                navigate("/DashboardMain/orderListConfig");
              }}
            >
              목록
            </Button>
          </div>
        </div>
      </div>






      <Snackbar 
        open={errSnack} 
        autoHideDuration={6000} 
        onClose={snackClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}                          
      >
        <Alert severity="error">수행을 실패 하였습니다!</Alert>
      </Snackbar>
      <Snackbar 
        open={succSnack} 
        autoHideDuration={6000} 
        onClose={snackClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}                          
      >
        <Alert severity="success">수행을 성공 하였습니다!</Alert>
      </Snackbar> 
      </>    
      )}

    </div>
  )
}

export default OrderEdit
